var React = require('react');

function Handle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0,0H10a0,0,0,0,1,0,0V4A4,4,0,0,1,6,8H4A4,4,0,0,1,0,4V0A0,0,0,0,1,0,0Z","transform":"translate(0 5)","key":0}),React.createElement("path",{"d":"M5,3l5,5H0Z","transform":"translate(0 -3)","key":1})]);
}

Handle.defaultProps = {"width":"10","height":"13","viewBox":"0 0 10 13"};

module.exports = Handle;

Handle.default = Handle;
